import BetModel from "../../../vendor_core/core/src/model/BetModel";
import GameModel from "../../../vendor_core/core/src/model/GameModel";
import { ICondition } from "../../../vendor_core/core/src/states/State";
import BURSpinModel from "../models/BURSpinModel";

export class BURHasBigWinCondition implements ICondition {
    public check(): boolean {
        return this.hasBigWin();
    }

    private hasBigWin(): boolean {
        return (
            this.getWinMultiplier() >=
            (GameModel.gameConfig as any).bigWinRatioLevels[0]
        );
    }

    private getWinMultiplier() {
        return BURSpinModel.cascades_total_win / BetModel.totalBet;
    }
}
